// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"Footer_footerContainer__3jGIY","videoContainer":"Footer_videoContainer__2VMjb","video":"Footer_video__2pLZA"};